import React from 'react';
import {
  number, string, func, shape, objectOf, oneOfType, arrayOf
} from 'prop-types';

import { schemaPartItemTypeValues, SurveySchemaPartEditorType } from '../../../../constants/types';
import { getTranslation, getTranslationWithLocale } from '../../../../i18n';
import SchemaPartItemPreview from '../SchemaPartItemPreview';

const getQuestionOrderByQuestionCode = (questions) =>
  questions.reduce((acc, question, idx) => {
    acc[question.code] = idx + 1;
    return acc;
  }, {});

const getQuestions = (schemaPart) =>
  schemaPart.surveySchemaPartItems.reduce((acc, item) => {
    if (schemaPartItemTypeValues.QUESTION === item.type) {
      return acc.concat(item.question);
    } if (schemaPartItemTypeValues.QUESTION_GROUP === item.type) {
      return acc.concat(item.questionGroup.questions);
    }
    return acc;
  }, []);

const SchemaPartQuestionsPreview = ({
  schemaPart, partNumber, answers, lang, translate
}) => {
  const questionOrder = getQuestionOrderByQuestionCode(getQuestions(schemaPart));
  const titleText = getTranslation(schemaPart.title, lang) || '';
  const partTitle = partNumber
    ? `${getTranslationWithLocale('survey.part', lang)} ${partNumber}${titleText && ': '}${titleText}`
    : titleText;

  return (
    <div>
      <h2 className="panel__title">{partTitle}</h2>
      {schemaPart.surveySchemaPartItems.map((item, idx) => (
        <SchemaPartItemPreview
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          item={item}
          lang={lang}
          answers={answers && answers[item.id] ? answers[item.id] : null}
          questionOrder={questionOrder}
          translate={translate}
        />
      ))}
    </div>
  );
};

const answerType = shape({
  questionId: number.isRequired,
  answer: oneOfType([string, arrayOf(number)])
});

SchemaPartQuestionsPreview.propTypes = {
  schemaPart: SurveySchemaPartEditorType.isRequired,
  partNumber: number,
  answers: objectOf(oneOfType([answerType, arrayOf(answerType)])),
  lang: string.isRequired,
  translate: func.isRequired
};

SchemaPartQuestionsPreview.defaultProps = {
  partNumber: 0,
  answers: undefined
};

export default SchemaPartQuestionsPreview;
